// client/src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './components/Login/AuthContext';
import PrivateRoute from './PrivateRoute';
import Navbar from './components/Common/Navbar';
import Footer from './components/Common/Footer';

// Composants publics
import Accueil from './components/Accueil/Accueil';
import Login from './components/Login';
import Register from './components/Register';
import MentionsLegales from './components/Common/MentionsLegales';
import PolitiqueDeConfidentialite from './components/Common/PolitiqueDeConfidentialite';
import CGV from './components/Common/CGV';
import Articles from './components/Articles/Article';
import ArticleDetail from './components/Accueil/Articles/ArticleDetail';
import ForgotPassword from './components/Login/ForgotPassword';
import Newsletter from './components/Common/Newsletter';

// Composants protégés
import Dashboard from './components/Dashboard/Dashboard';
import Profile from './components/Profile/Profile';
import Settings from './components/Settings/Settings';
// Banque
import Bank from './components/Banque/bank';
import RapprochementBancaire from './components/Banque/RapprochementBancaire';
import AccountDashboard from './components/Banque/AccountDashboard';
import { SocialMain, AjouterEmploye, BulletinDeSalaire } from './components/Social';
import FicheSalarie from './components/Social/components/FicheSalarie';
import Reports from './components/Reports';
import BilanComptable from './components/Reports/Comptables/BilanComptable';
import CompteResultat from './components/Reports/Comptables/CompteResultat';
import GrandLivre from './components/Reports/Comptables/GrandLivre';
import BalanceComptable from './components/Reports/Comptables/BalanceComptable';
import DeclarationTVA from './components/Reports/Fiscaux/DeclarationTVA';
import LiasseFiscale from './components/Reports/Fiscaux/LiasseFiscale';
import ImpotSocietes from './components/Reports/Fiscaux/ImpotSocietes';
import CFECVAE from './components/Reports/Fiscaux/CFECVAE';
import DeclarationSociale from './components/Reports/Sociaux/DeclarationSociale';
import MasseSalariale from './components/Reports/Sociaux/MasseSalariale';
import RecapCotisations from './components/Reports/Sociaux/Cotisations';
import TableauTresorerie from './components/Reports/Analytiques/TableauTresorerie';
import RatiosFinanciers from './components/Reports/Analytiques/RatiosFinanciers';
import RelevésBancaires from './components/Tresorerie/RelevésBancaires';
import PrevisionsTresorerie from './components/Tresorerie/PrevisionsTresorerie';
import FluxTresorerie from './components/Tresorerie/FluxTresorerie';
import ListeDepenses from './components/Depenses/ListeDepenses';
import AjouterDepense from './components/Depenses/AjouterDepense';
import CategoriesDepenses from './components/Depenses/CategoriesDepenses';

//Investissements
import SuiviInvestissements from './components/Investissements/SuiviInvestissements';
import Amortissements from './components/Investissements/Amortissements';
import PlanInvestissement from './components/Investissements/PlanInvestissement';

//Financements
import PretsCredits from './components/Financement/PretsCredits';
import TableauEmprunts from './components/Financement/TableauEmprunts';
import Leasing from './components/Financement/Leasing';
import RatiosClés from './components/AnalyseFinanciere/RatiosCles';
import SeuilRentabilite from './components/AnalyseFinanciere/SeuilRentabilite';
import Benchmark from './components/AnalyseFinanciere/BenchmarkSectoriel';
import CreerBudget from './components/Budget/CreerBudget';
import SuiviBudget from './components/Budget/SuiviBudget';
import EcartsBudget from './components/Budget/EcartsBudget';
import ClientForm from './components/Clients/ClientForm';

// Nouveaux composants pour les routes manquantes
import CreerFactureAchat from './components/Facturation/Achat/CreerFactureAchat';
import ListeFacturesAchat from './components/Facturation/Achat/ListeFacturesAchat';
import RelancerFournisseur from './components/Facturation/Achat/RelancerFournisseur';
import ListeFacturesVente from './components/Facturation/Vente/ListeFacturesVente';
import CreerFactureVente from './components/Facturation/Vente/CreerFactureVente';
import CreerAvoir from './components/Facturation/Vente/Avoirs/CreerAvoir';
import ListeAvoirs from './components/Facturation/Vente/Avoirs/ListeAvoirs';
import ListeDevis from './components/Facturation/Devis/ListeDevis';
import CreerDevis from './components/Facturation/Devis/CreerDevis';
import SuiviPaiements from './components/Facturation/SuiviPaiements';
import StatistiquesFacturation from './components/Facturation/StatistiquesFacturation';
import CreerMouvementBancaire from './components/Banque/MouvementBancaire/CreerMouvementBancaire';
import ListeMouvementsBancaires from './components/Banque/MouvementBancaire/ListeMouvementsBancaires';
import ListeClients from './components/Contacts/Clients/ListeClients';
import ListeFournisseurs from './components/Contacts/Fournisseurs/ListeFournisseurs';
import AjouterFournisseur from './components/Contacts/Fournisseurs/AjouterFournisseur';
import ContratsClients from './components/Contacts/ContratsClients';
import ContratsFournisseurs from './components/Contacts/ContratsFournisseurs';
import HistoriqueTransactions from './components/Contacts/HistoriqueTransactions';

//Stock
import ListeProduitsServices from './components/Stocks/Produits/ListeProduitsServices';
import AjouterProduitService from './components/Stocks/Produits/AjouterProduitService';
import Inventaire from './components/Stocks/Inventaire';
import AlertesStock from './components/Stocks/AlertesStock';
import ValuationStocks from './components/Stocks/ValuationStocks';

//Ecritures comptables
import EcrituresComptables from './components/Comptabilité/EcrituresComptables';
import CreerEcritureComptable from './components/Comptabilité/CreerEcritureComptable';
import PlanComptable from './components/Comptabilité/PlanComptable';
import JournalGeneral from './components/Comptabilité/JournalGeneral';
import ClotureExercice from './components/Comptabilité/ClotureExercice';
// Projets
import ListeProjets from './components/Projets/ListeProjets';
import CreerProjet from './components/Projets/CreerProjet';
import SuiviTemps from './components/Projets/SuiviTemps';
import FacturationParProjet from './components/Projets/FacturationParProjet';
import BudgetParProjet from './components/Projets/BudgetParProjet';
import RentabiliteProjets from './components/Projets/RentabiliteProjets';

// Abonnement
import Abonnement from './components/Abonnement/Abonnement';
import ChangerFormule from './components/Abonnement/ChangerFormule';
import HistoriquePaiementsAbonnement from './components/Abonnement/HistoriquePaiements';
import FacturesAbonnement from './components/Abonnement/FacturesAbonnement';
import ModesPaiement from './components/Abonnement/ModesPaiement';
import ChangerMotDePasse from './components/Securite/ChangerMotDePasse';
import Authentification2FA from './components/Securite/Authentification2FA';
import AppareilsConnectes from './components/Securite/AppareilsConnectes';
import JournalActivites from './components/Securite/JournalActivites';
//Notifications
import PreferencesNotifications from './components/Notifications/PreferencesNotifications';
import HistoriqueNotifications from './components/Notifications/HistoriqueNotifications';

//Support
import CentreAide from './components/Support/CentreAide';
import ContactPage from './components/Common/ContactPage';

import ApplicationsConnectees from './components/Integrations/ApplicationsConnectees';
import APIDeveloppeurs from './components/Integrations/APIDeveloppeurs';
import Webhooks from './components/Integrations/Webhooks';

function App() {
  return (
    <AuthProvider>
      <Router>
        <Navbar />
        <Routes>
          {/* Routes publiques */}
          <Route path="/" element={<Accueil />} />
          <Route path="/accueil" element={<Accueil />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/mentions-legales" element={<MentionsLegales />} />
          <Route path="/politique-de-confidentialite" element={<PolitiqueDeConfidentialite />} />
          <Route path="/cgv" element={<CGV />} />
          <Route path="/articles" element={<Articles />} />
          <Route path="/articles/:slug" element={<ArticleDetail />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/newsletter" element={<Newsletter />} />
          <Route path="/contact" element={<ContactPage />} />

          {/* Routes protégées */}
          <Route element={<PrivateRoute />}>
            {/* Dashboard */}
            <Route path="/dashboard" element={<Dashboard />} />

            {/* Facturation */}
            <Route path="/factures/achat/creer" element={<CreerFactureAchat />} />
            <Route path="/factures/achat/liste" element={<ListeFacturesAchat />} />
            <Route path="/factures/achat/relances" element={<RelancerFournisseur />} />
            <Route path="/factures/vente/liste" element={<ListeFacturesVente />} />
            <Route path="/factures/vente/creer" element={<CreerFactureVente />} />
            <Route path="/factures/vente/avoirs/creer" element={<CreerAvoir />} />
            <Route path="/factures/vente/avoirs/liste" element={<ListeAvoirs />} />
            <Route path="/factures/devis/liste" element={<ListeDevis />} />
            <Route path="/factures/devis/creer" element={<CreerDevis />} />
            <Route path="/factures/suivi-paiements" element={<SuiviPaiements />} />
            <Route path="/factures/statistiques" element={<StatistiquesFacturation />} />

            {/* Trésorerie & Banque */}
            <Route path="/banque/mouvement/creer" element={<CreerMouvementBancaire />} />
            <Route path="/banque/mouvement/liste" element={<ListeMouvementsBancaires />} />
            <Route path="/banque/rapprochement" element={<RapprochementBancaire />} />
            <Route path="/banque/relevés" element={<RelevésBancaires />} />
            <Route path="/banque/previsions" element={<PrevisionsTresorerie />} />
            <Route path="/banque/flux" element={<FluxTresorerie />} />
            <Route path="/banque/categories" element={<CategoriesDepenses />} />
            <Route path="/banque/transferts" element={<CreerMouvementBancaire />} />

            {/* Clients & Fournisseurs */}
            <Route path="/contacts/clients" element={<ListeClients />} />
            <Route path="/contacts/clients/ajouter" element={<ClientForm />} />
            <Route path="/contacts/fournisseurs" element={<ListeFournisseurs />} />
            <Route path="/contacts/fournisseurs/ajouter" element={<AjouterFournisseur />} />
            <Route path="/contacts/contrats-clients" element={<ContratsClients />} />
            <Route path="/contacts/contrats-fournisseurs" element={<ContratsFournisseurs />} />
            <Route path="/contacts/historique" element={<HistoriqueTransactions />} />

            {/* Stocks & Inventaire */}
            <Route path="/stocks/produits" element={<ListeProduitsServices />} />
            <Route path="/stocks/produits/ajouter" element={<AjouterProduitService />} />
            <Route path="/stocks/inventaire" element={<Inventaire />} />
            <Route path="/stocks/alertes" element={<AlertesStock />} />
            <Route path="/stocks/valuation" element={<ValuationStocks />} />

            {/* Comptabilité */}
            <Route path="/comptabilité/ecritures" element={<EcrituresComptables />} />
            <Route path="/comptabilité/ecritures/creer" element={<CreerEcritureComptable />} />
            <Route path="/comptabilité/plan-comptable" element={<PlanComptable />} />
            <Route path="/comptabilité/journal" element={<JournalGeneral />} />
            <Route path="/comptabilité/balance" element={<BalanceComptable />} />
            <Route path="/comptabilité/grand-livre" element={<GrandLivre />} />
            <Route path="/comptabilité/cloture" element={<ClotureExercice />} />

            {/* Projets & Temps */}
            <Route path="/projets/liste" element={<ListeProjets />} />
            <Route path="/projets" element={<ListeProjets />} />
            <Route path="/projets/creer" element={<CreerProjet />} />
            <Route path="/projets/:id" element={<CreerProjet />} />
            <Route path="/projets/temps" element={<SuiviTemps />} />
            <Route path="/projets/facturation" element={<FacturationParProjet />} />
            <Route path="/projets/budget" element={<BudgetParProjet />} />
            <Route path="/projets/rentabilite" element={<RentabiliteProjets />} />

            {/* Reports */}
            <Route path="/reports" element={<Reports />} />
            <Route path="/reports/comptables/bilan" element={<BilanComptable />} />
            <Route path="/reports/comptables/compte-resultat" element={<CompteResultat />} />
            <Route path="/reports/comptables/grand-livre" element={<GrandLivre />} />
            <Route path="/reports/comptables/balance" element={<BalanceComptable />} />
            <Route path="/reports/fiscaux/declaration-tva" element={<DeclarationTVA />} />
            <Route path="/reports/fiscaux/liasse-fiscale" element={<LiasseFiscale />} />
            <Route path="/reports/fiscaux/impot-societes" element={<ImpotSocietes />} />
            <Route path="/reports/fiscaux/cfecvae" element={<CFECVAE />} />
            <Route path="/reports/sociaux/declaration-sociale" element={<DeclarationSociale />} />
            <Route path="/reports/sociaux/masse-salariale" element={<MasseSalariale />} />
            <Route path="/reports/sociaux/cotisations" element={<RecapCotisations />} />
            <Route path="/reports/analytiques/trésorerie" element={<TableauTresorerie />} />
            <Route path="/reports/analytiques/ratios" element={<RatiosFinanciers />} />

            {/* Finance */}
            <Route path="/finance/relevés-bancaires" element={<RelevésBancaires />} />
            <Route path="/finance/previsions-tresorerie" element={<PrevisionsTresorerie />} />
            <Route path="/finance/flux-tresorerie" element={<FluxTresorerie />} />
            <Route path="/finance/liste-depenses" element={<ListeDepenses />} />
            <Route path="/finance/ajouter-depense" element={<AjouterDepense />} />
            <Route path="/finance/categories-depenses" element={<CategoriesDepenses />} />
            <Route path="/finance/rapprochement" element={<RapprochementBancaire />} />
            <Route path="/finance/suivi-investissements" element={<SuiviInvestissements />} />
            <Route path="/finance/amortissements" element={<Amortissements />} />
            <Route path="/finance/plan-investissement" element={<PlanInvestissement />} />
            <Route path="/finance/prets-credits" element={<PretsCredits />} />
            <Route path="/finance/tableau-emprunts" element={<TableauEmprunts />} />
            <Route path="/finance/leasing" element={<Leasing />} />
            <Route path="/finance/ratios-cles" element={<RatiosClés />} />
            <Route path="/finance/seuil-rentabilite" element={<SeuilRentabilite />} />
            <Route path="/finance/benchmark" element={<Benchmark />} />
            <Route path="/finance/creer-budget" element={<CreerBudget />} />
            <Route path="/finance/suivi-budget" element={<SuiviBudget />} />
            <Route path="/finance/ecarts-budget" element={<EcartsBudget />} />

            {/* Social */}
            <Route path="/social" element={<SocialMain />} />
            <Route path="/bulletin-de-salaire" element={<BulletinDeSalaire />} />
            <Route path="/ajouter-employe" element={<AjouterEmploye />} />
            <Route path="/collaborateurs/:id" element={<FicheSalarie />} />

            {/* Bank */}
            <Route path="/bank" element={<Bank />} />
            <Route path="/solde_bancaire" element={<AccountDashboard />} />

            {/* Mon Compte */}
            <Route path="/profile" element={<Profile />} />
            <Route path="/settings" element={<Settings />} />
            <Route path="/settings/affichage" element={<Settings />} />
            <Route path="/settings/langue" element={<Settings />} />

            {/* Abonnement */}
            <Route path="/abonnement" element={<Abonnement />} />
            <Route path="/abonnement/changer" element={<ChangerFormule />} />
            <Route path="/abonnement/historique" element={<HistoriquePaiementsAbonnement />} />
            <Route path="/abonnement/factures" element={<FacturesAbonnement />} />
            <Route path="/abonnement/modes-paiement" element={<ModesPaiement />} />

            {/* Sécurité */}
            <Route path="/securite/mot-de-passe" element={<ChangerMotDePasse />} />
            <Route path="/securite/2fa" element={<Authentification2FA />} />
            <Route path="/securite/appareils" element={<AppareilsConnectes />} />
            <Route path="/securite/journal" element={<JournalActivites />} />

            {/* Notifications */}
            <Route path="/notifications/preferences" element={<PreferencesNotifications />} />
            <Route path="/notifications/historique" element={<HistoriqueNotifications />} />

            {/* Support */}
            <Route path="/support/centre-aide" element={<CentreAide />} />
            <Route path="/support/contact" element={<ContactPage />} />

            {/* Intégrations */}
            <Route path="/integrations/applications" element={<ApplicationsConnectees />} />
            <Route path="/integrations/api" element={<APIDeveloppeurs />} />
            <Route path="/integrations/webhooks" element={<Webhooks />} />
          </Route>
        </Routes>
        <Footer />
      </Router>
    </AuthProvider>
  );
}

export default App;
